import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { CALL_TO_BOOK } from '../../../../config/text/text';
import ThemeContext from '../../../../providers/ThemeProvider';
import PrimaryButton from '../../../_generic/button/PrimaryButton';
import CompanyLogos from '../logos/CompanyLogos';

const DealLeadGen = ({ buttonRef, deal = {}, isTravel = false }) => {
  const theme = useContext(ThemeContext);

  if (!deal || !deal.leadGen || !deal.business) {
    return null;
  }

  const BusinessName = () => {
    return (
      <p className="lead-gen__name">
        <b>{deal.business.name}</b>
      </p>
    );
  };

  const Logo = () => {
    return (
      <>
        <div className="lead-gen__logo">
          <CompanyLogos deal={deal} />
        </div>
        <style jsx>{`
          .lead-gen__logo {
            pointer-events: none;
          }
          :global(.lead-gen .deal-merchant-logo) {
            width: 100%;
          }
          .lead-gen__logo {
            display: inline-block;
            justify-content: center;
            margin: 0 auto;
          }
          @media (max-width: ${theme.breakpoints.mdDown}) {
            .lead-gen__logo {
              display: inline-block;
              justify-content: center;
              margin: 0 auto;
            }
          }
          @media (max-width: ${theme.breakpoints.smDown}) {
            .lead-gen__logo {
              display: none;
            }
          }
        `}</style>
      </>
    );
  };

  const BusinessHours = () => {
    return <p className="lead-gen__hours">{deal.leadGen.hours}</p>;
  };

  const TravelDealLeadGen = () => {
    return (
      <>
        <div className="lead-gen">
          <p className="lead-gen__action">{CALL_TO_BOOK}:</p>
          <a
            className="primary-button size-largest deal-main-deal__buy full-width margin size-xlarge"
            href={`tel:${deal.leadGen.number}`}
            ref={buttonRef}
          >
            <PrimaryButton
              ariaLabel={CALL_TO_BOOK}
              className="full-width margin size-largest"
            >
              {deal.leadGen.displayNumber}
            </PrimaryButton>
          </a>
          <BusinessHours />
          <BusinessName />
          <Logo />
        </div>
        <style jsx>{`
          .lead-gen {
            color: ${theme.colors.textonprimary};
            background-color: #fff;
            padding: 10px;
            margin-bottom: 8px;
            text-align: center;
          }
          .lead-gen a {
            color: #000;
            text-decoration: none;
          }
          .lead-gen__link {
            color: #000;
          }
          .lead-gen__action {
            display: inline-block;
            font-size: 30px;
            margin-bottom: 4px;
            text-decoration: none;
            font-weight: bolder;
            color: ${theme.colors.dealviewbutton};
          }
          :global(.lead-gen__name, .lead-gen__hours) {
            margin-bottom: 4px;
            color: ${theme.colors.dealviewbutton};
            font-size: 18px;
          }

          @media (max-width: ${theme.breakpoints.mdDown}) {
            .lead-gen {
              margin: 0;
            }
            .lead-gen__logo {
              display: inline-block;
              justify-content: center;
              margin: 0 auto;
            }
          }
          @media (max-width: ${theme.breakpoints.smDown}) {
            :global(.lead-gen__name) {
              display: none;
            }
            .lead-gen {
              border-top: 1px solid ${theme.colors.dealline};
            }
          }
        `}</style>
      </>
    );
  };

  const DefaultLeadGen = () => {
    return (
      <>
        <div className="lead-gen">
          <a
            className="lead-gen__link"
            href={`tel:${deal.leadGen.number}`}
            ref={buttonRef}
          >
            <p className="lead-gen__action">{CALL_TO_BOOK}:</p>
            <BusinessName deal={deal} />
            <p className="lead-gen__number">{deal.leadGen.displayNumber}</p>
            <BusinessHours />
          </a>
          <Logo />
        </div>
        <style jsx>{`
          .lead-gen {
            background-color: ${theme.colors.primary};
            color: ${theme.colors.textonprimary};
            padding: 10px;
            margin-bottom: 8px;
            margin-left: 8px;
            margin-right: 8px;
            text-align: center;
          }
          .lead-gen__link {
            text-decoration: none;
            color: ${theme.colors.textonprimary};
          }
          .lead-gen__action {
            display: inline-block;
            font-size: 20px;
            margin-bottom: 4px;
            border-bottom: 1px solid ${theme.colors.textonprimary};
          }
          .lead-gen__number {
            font-size: 28px;
            font-weight: bold;
            margin-bottom: 4px;
            line-height: 1.2em;
          }
          :global(.lead-gen__name, .lead-gen__hours) {
            font-style: italic;
            margin-bottom: 4px;
          }
          @media (max-width: ${theme.breakpoints.mdDown}) {
            .lead-gen {
              margin: 0;
            }
          }
        `}</style>
      </>
    );
  };

  return isTravel ? <TravelDealLeadGen /> : <DefaultLeadGen />;
};

DealLeadGen.propTypes = {
  buttonRef: PropTypes.object,
  deal: PropTypes.object,
  isTravel: PropTypes.bool,
};

export default DealLeadGen;
